$(window).on('load',function(){
AOS.init({
	offset:200,
	duration:500,
	delay: 100,
	once:true,
});
});

//マーカー
$(window).scroll(function (){
	$('.recovery-line').each(function(){
	  let hit		= $(this).offset().top;
	  let scroll	= $(window).scrollTop();
	  let wHeight	= $(window).height();
  
	  if (scroll > hit - wHeight + wHeight/10){
		$(this).addClass('recovery-on');
	  } else {
	   $(this).removeClass('recovery-on');
	  }
	});
});